const cartDrawerDonation = () => {
    const selectors = {
        cartDrawerDonation: '[data-cart-drawer-donation]',
        donationVariant: 'data-cart-drawer-donation-variant',
    };
    const classes = {
        applyDonation: 'drawer__donation--active',
    };
    const updateCartDonation = () => {
        const cartDrawerDonation = document.querySelector(selectors.cartDrawerDonation);
        if (cartDrawerDonation) {
            const donationVariant = cartDrawerDonation.getAttribute(selectors.donationVariant);
            cartDrawerDonation.addEventListener('click', () => {
                cartDrawerDonation.classList.add(classes.applyDonation);
                const donationData = {
                    id: donationVariant,
                    quantity: 1,
                };
                fetch('/cart/add.js', {
                    body: JSON.stringify(donationData),
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest',
                    },
                    method: 'POST',
                })
                    .then((response) => {
                    return;
                })
                    .then(() => {
                    window.dispatchEvent(new CustomEvent('frank-green:donation-update', {}));
                })
                    .catch((err) => {
                    console.error(err);
                });
            });
        }
    };
    updateCartDonation();
    window.addEventListener('frank-green:cart-reloaded', () => {
        updateCartDonation();
    });
};
export { cartDrawerDonation };
